export default function immutableSplice(start, end) {
  for (var _len = arguments.length, items = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    items[_key - 2] = arguments[_key];
  }
  return function (arr) {
    var copy = Array.from(arr);
    copy.splice.apply(copy, [start, end].concat(items));
    return copy;
  };
}